export interface Environment {
    swapApiUrl: string;
    swapClientApiUrl?: string;
    priceUrl?: string;
    stage?: "dev" | "prd" | "stg";
};

export const defaultConfig: Environment ={
    swapApiUrl: "http://nohost",
    swapClientApiUrl: "http://nohost",
    priceUrl: "http://nohost",
    stage: "dev",
};

class Config {
    config: Environment = defaultConfig;
}

export const env = new Config();

export const configUrl = "config/config.json";